enum DiscountType {
    Cash,
    Percent
}

export { DiscountType };
